import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  Tab: {
    currentPage: 1,
    currentFilter: "all",
    currentPageSize: 10,
    sortBy: "",
    sortOrder: "desc",
    search: "",
    clear: false,
    activeTab: "delivery-challan",
  },
  showOffcanvas: false,
  showConfirmationModal: false,
  isEdit: false,
  selectedRows: [],
  selectedEditId: null,
  editData: {},
  editDataStatus: "idle",
  selectedCancelIds: [],
  printChellanData: {},
};

export const getDeliveryChallanEditData = createAsyncThunk(
  "deliveryChallan/edit",
  async (params, { rejectWithValue }) => {
    try {
      const api = await getAxiosInstance();
      const response = await api.post(`delivery/edit-delivery-challan`, {
        id: params?.id,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const deliveryChallanSlice = createSlice({
  name: "deliveryChallan",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    resetConfig: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDeliveryChallanEditData.pending, (state) => {
        state.editDataStatus = "pending";
      })
      .addCase(getDeliveryChallanEditData.fulfilled, (state, action) => {
        state.editDataStatus = "fulfilled";
        state.editData = action.payload?.data;
      })
      .addCase(getDeliveryChallanEditData.rejected, (state) => {
        state.editDataStatus = "failed";
      });
  },
});

export const { updateConfig, resetConfig } = deliveryChallanSlice.actions;

export default deliveryChallanSlice.reducer;
